import { NeedsListView } from "./NeedsListView";

export const MineBehov = () => (
  <NeedsListView
    titleKey="My needs"
    descriptionKey="Needs you have registered."
    mineOnly={true}
    urlStatusSync={false}
  />
);
